import {
  cloneObject,
  deserify,
  getLocalStorage,
  getTeacherSubjectName,
  IconWrapper,
  IStyles,
  Loader,
  PrimaryButton,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import PrintIcon from '@mui/icons-material/Print';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  setCurrentQPGTemplateInfo,
  setQPGGeneratedTemplates,
  setQPGSettingsConfig,
  setQPGContent,
  setQPGSubsectionData,
} from '../../../reducer/assessmentFlow.slice';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../reduxStore/reduxHooks';
import {
  MultiSubjectSubSection,
  QuestionPaperTemplate,
  QuestionSection,
  SectionQuestionMetaData,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import {
  SubSectionQuestionType,
  SubSectionTypeV2,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import {
  setToastInfo,
  setToastInfoV2,
} from '../../../../../pages/Home/reducer/homeDashboard.slice';
import { getQuestionEnumArrayFromQuestionTypes } from '../../../../../pages/Homework/ReviewHomework/functions';
import AddIcon from '@mui/icons-material/Add';
import { AiPromptTextEditor } from '../../../components/AirPromptTextEditor';
// import { QPGPromptSuggestionButtons } from './QPGPromptSuggestionButtons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Question_QuestionEnum } from '@protos/content_management/content.db_pb';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';

import { AssessmentCreationEnum } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { getDifficultyLevelFromString } from '../../../Common/ReviewAssessment/functions';
import { SaveTemplatePopup } from '../../../QuestionPaperGenerator/QuestionPaperCreate/components/SaveTemplatePopup';
import { ValidationPopup } from '../../../QuestionPaperGenerator/QuestionPaperCreate/components/ValidationPopup';
import { QPGSubSection } from './QPGSubSection';
import { numberToAlphabet } from '../../../QuestionPaperGenerator/ReviewQuestionPaper/utils';
import {
  areAllSubSectionQuestionsFilled,
  createMultiSubjectSectionTemplate,
  getInitialRemainingByType,
  hasAnyQuestionTypeRemaining,
} from '../../../utils/QPGv2.utils';

const style: IStyles = {
  root: {
    // mx: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    mt: { xs: pxToRem(20), md: pxTovW(40) },
  },
  subSectionAndPromptBox: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    // justifyContent: 'space-between',
    gap: { xs: pxToRem(10), md: pxTovW(25) },
  },
  subSectionAndAddBox: {
    // width: { xs: '100%', md: pxTovW(990) },
    width: '100%',
    boxSizing: 'border-box',
    margin: 'auto',
  },
  subSectionBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectPaperFormatBox: {
    width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
    gap: { xs: pxToRem(10), md: pxTovW(20) },
  },
  selectMenuRootStyles: {
    height: { xs: pxToRem(40), md: pxTovW(70), lg: pxTovW(56) },
    width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
    backgroundColor: '#FFFFFF',
    border: '1px solid #55ACFF',
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:focus-visible .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-select > em': {
      // backgroundColor: 'red',
      fontStyle: 'normal !important',
      fontFamily: 'Lato',
    },
  },
  qpgSubSectionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    // marginY: { xs: pxToRem(10), md: pxTovW(41) },
    marginBottom: { xs: pxToRem(10), md: pxTovW(40) },
    cursor: 'grab',
  },
  saveTemplateAndAddSectionBox: {
    width: '100%',
    display: 'flex',
    justifyContent: { xs: 'center', md: 'flex-end' },
    flexWrap: 'wrap',
    gap: { xs: pxToRem(10), md: pxTovW(16) },
  },
  saveTemplateButton: {
    width: { xs: 'max-content', md: 'max-content' },
    height: { xs: pxToRem(40), md: pxTovW(64) },
    gap: { xs: pxToRem(8), md: pxTovW(12) },
    backgroundColor: '#0AA34F',
    borderRadius: { xs: pxToRem(8), md: pxTovW(10) },
    boxShadow: '0px 4px 10px rgba(10, 163, 79, 0.28)',
    paddingX: { xs: pxToRem(14), md: pxTovW(20) },
    '&:hover': {
      backgroundColor: '#089246',
      boxShadow: '0px 4px 10px rgba(10, 163, 79, 0.32)',
    },
    '&:disabled': {
      backgroundColor: '#0AA34F',
      color: '#fff',
      opacity: 0.5,
    },
  },
  saveTemplateIcon: {
    backgroundColor: '#044822',
    borderRadius: '50%',
    padding: { xs: pxToRem(5), md: pxTovW(5) },
    width: { xs: pxToRem(20), md: pxTovW(30) },
    height: { xs: pxToRem(20), md: pxTovW(30) },
  },
  addSectionButton: {
    width: { xs: 'max-content', md: 'max-content' },
    height: { xs: pxToRem(40), md: pxTovW(64) },
    gap: { xs: pxToRem(8), md: pxTovW(10) },
    backgroundColor: '#007CDC',
    borderRadius: { xs: pxToRem(8), md: pxTovW(10) },
    boxShadow: 'none',
    '&:disabled': {
      backgroundColor: '#007CDC',
      color: '#fff',
      opacity: 0.5,
    },
    '&:hover': {
      backgroundColor: '#007CDC',
      boxShadow: 'none',
    },
  },
  addSectionIcon: {
    backgroundColor: '#003464',
    borderRadius: '50%',
    padding: { xs: pxToRem(5), md: pxTovW(5) },
    width: { xs: pxToRem(20), md: pxTovW(30) },
    height: { xs: pxToRem(20), md: pxTovW(30) },
  },
  previewPrintableButton: {
    width: { xs: 'max-content', md: 'max-content' },
    height: { xs: pxToRem(40), md: pxTovW(64) },
    gap: { xs: pxToRem(8), md: pxTovW(10) },
    backgroundColor: '#f9c80d',
    borderRadius: { xs: pxToRem(8), md: pxTovW(10) },
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#E0B40B',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#f9c80d',
      color: '#fff',
      opacity: 0.5,
    },
  },
  previewPrintableIcon: {
    backgroundColor: '#90700d',
    borderRadius: '50%',
    padding: { xs: pxToRem(5), md: pxTovW(5) },
    width: { xs: pxToRem(20), md: pxTovW(30) },
    height: { xs: pxToRem(20), md: pxTovW(30) },
  },
  aiPromptTextEditorBox: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    width: { xs: '100%', md: pxTovW(425) },
    minWidth: { xs: '100%', md: pxTovW(425) },
  },
  aiPromptTextEditorRootBox: {
    height: { xs: 'max-content', md: 'max-content' },
  },
};

interface IProps {
  isTemplateValid: boolean;
  setIsTemplateValid: React.Dispatch<React.SetStateAction<boolean>>;
  subjectId: number;
  totalMarks: number;
  preferredMarks: number;
}
export const QPGCreationAddQuestionType = (props: IProps) => {
  const {
    subjectId,
    isTemplateValid,
    setIsTemplateValid,
    totalMarks,
    preferredMarks,
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  // const [sections, setSections] = useState(SectionList);
  const {
    generated_qpg_templates,
    current_qpg_template_info,
    qpg_settings_config,
    qpg_selected_chapter_data,
    qpg_subsection_data,
    qpg_content,
    qpg_selected_section_index,
    qpg_selected_section_number,
  } = deserify(useAppSelector((state) => state.assessment));
  const dispatch = useAppDispatch();
  const dragItem = useRef<number | null>(null);
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );
  const availableQuestionTypes = qpg_settings_config?.allow_ai_questions
    ? [
        Question_QuestionEnum.QUESTION_TYPE_MCQS,
        Question_QuestionEnum.QUESTION_TYPE_MCQM,
        Question_QuestionEnum.QUESTION_TYPE_FIB,
        Question_QuestionEnum.QUESTION_TYPE_TF,
        Question_QuestionEnum.QUESTION_TYPE_VERY_SHORT,
        Question_QuestionEnum.QUESTION_TYPE_SHORT,
        Question_QuestionEnum.QUESTION_TYPE_LONG,
        // TODO: Competency Support
        // Question_QuestionEnum.QUESTION_TYPE_CBQ,
      ]
    : getQuestionEnumArrayFromQuestionTypes(
        qpg_settings_config?.no_ofQuestions_by_types || {}
      );
  const moduleIds =
    qpg_selected_chapter_data?.chapters
      .flatMap((chapter) => [
        chapter.chapterId,
        ...chapter.topics.map((topic) => topic.topicId),
      ])
      ?.sort((a, b) => a - b) || [];
  const [displaySaveTemplatePopup, setDisplaySaveTemplatePopup] =
    useState<boolean>(false);
  const [validationStatus, setValidationStatus] = useState<
    { type: 'success' | 'error'; heading?: string; message: string } | undefined
  >(undefined);
  const teacher_id = getLocalStorage('userId');
  const [isTemplateEdited, setIsTemplateEdited] = useState(false);
  const [selectedSectionList, setSelectedSectionList] = useState<
    QuestionSection[]
  >([]);
  const { subject_id } = useParams();
  const {
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler,
  } = useCommonServiceClientContext();

  // ----------------------------------------------------

  const handleAddSection = async () => {
    setIsTemplateEdited(true);
    const currentSubSectionData = qpg_subsection_data ?? [];
    const newSubSection = new SubSectionTypeV2({
      subSectionName: `Sub Section ${
        (qpg_selected_section_index ?? 0) + 1
      } ${numberToAlphabet(currentSubSectionData.length + 1)}`,
      sectionNumber: currentSubSectionData.length + 1,
      subSectionQuestions: [
        new SubSectionQuestionType({
          questionType: Question_QuestionEnum.QUESTION_TYPE_UNDEFINED,
          noOfQuestion: 0,
          marks: 0,
          isAlternateEnable: false,
        }),
      ],
    });

    dispatch(setQPGSubsectionData([...currentSubSectionData, newSubSection]));
    // dispatch(setQPGSubsectionData([]));

    // Add new subsection to qpg_content for the selected subject section
    const sectionIndex = qpg_selected_section_index ?? 0;
    if (qpg_content?.multiSubjectSections?.[sectionIndex]) {
      const sections = [...qpg_content.multiSubjectSections];
      const selectedSection = cloneObject(
        qpg_content.multiSubjectSections[sectionIndex]
      );
      const currentSubSections = selectedSection.multiSubjectSubSections ?? [];
      const newMultiSubjectSubSection = new MultiSubjectSubSection({
        subSectionName: newSubSection.subSectionName,
        subSectionNo: currentSubSections.length + 1,
        subSectionMetaData: [],
      });
      selectedSection.multiSubjectSubSections = [
        ...currentSubSections,
        newMultiSubjectSubSection,
      ];
      sections[sectionIndex] = selectedSection;
      const updatedContent = cloneObject(qpg_content);
      updatedContent.multiSubjectSections = sections;
      dispatch(setQPGContent(updatedContent));
    }

    const newSectionList =
      selectedSectionList.length > 0
        ? [...selectedSectionList, new QuestionSection({})]
        : [new QuestionSection({})];
    setSelectedSectionList(newSectionList);
    dispatch(
      setCurrentQPGTemplateInfo({
        ...current_qpg_template_info,
        questionSectionInfo: newSectionList,
      })
    );

    // await interactionEvent({
    //   context: 'Question_paper_generator',
    //   name: 'ADD_SECTION',
    //   pathSegments: pathSegments,
    //   isOffline: isOffline,
    // });
  };

  // ----------------------------------------------------

  const handleUpdateSubSection = (index: number, section: QuestionSection) => {
    setIsTemplateEdited(true);
    const updatedSections = [...selectedSectionList];
    updatedSections[index] = section;
    setSelectedSectionList(updatedSections);
    dispatch(
      setCurrentQPGTemplateInfo({
        ...current_qpg_template_info,
        questionSectionInfo: updatedSections,
      })
    );
    // console.log('Updated Section:', updatedSections);
    // console.log('selectedSectionList:', selectedSectionList);
  };

  // ----------------------------------------------------

  const handleDeleteSubSection = (index: number) => {
    setIsTemplateEdited(true);
    const updatedSections = [...selectedSectionList];
    updatedSections.splice(index, 1);
    setSelectedSectionList(updatedSections);

    const sectionIndex = qpg_selected_section_index ?? 0;
    const currentSubSectionData = qpg_subsection_data ?? [];
    const updatedSubSectionData = currentSubSectionData
      .filter((_, i) => i !== index)
      .map(
        (sub, i) =>
          new SubSectionTypeV2({
            ...sub,
            sectionNumber: i + 1,
            subSectionName: `Sub Section ${sectionIndex + 1} ${numberToAlphabet(
              i + 1
            )}`,
          })
      );
    dispatch(setQPGSubsectionData(updatedSubSectionData));

    // Remove subsection from qpg_content for the selected subject section
    if (qpg_content?.multiSubjectSections?.[sectionIndex]) {
      const sections = [...qpg_content.multiSubjectSections];
      const selectedSection = cloneObject(
        qpg_content.multiSubjectSections[sectionIndex]
      );
      const currentSubSections = selectedSection.multiSubjectSubSections ?? [];
      const updatedSubSections = currentSubSections
        .filter((_, i) => i !== index)
        .map(
          (sub, i) =>
            new MultiSubjectSubSection({
              ...sub,
              subSectionNo: i + 1,
              subSectionName: `Sub Section ${
                sectionIndex + 1
              } ${numberToAlphabet(i + 1)}`,
            })
        );
      selectedSection.multiSubjectSubSections = updatedSubSections;
      sections[sectionIndex] = selectedSection;
      const updatedContent = cloneObject(qpg_content);
      updatedContent.multiSubjectSections = sections;
      dispatch(setQPGContent(updatedContent));
    }

    // dispatch(
    //   setCurrentQPGTemplateInfo({
    //     ...current_qpg_template_info,
    //     questionSectionInfo: updatedSections,
    //   })
    // );
  };

  // ----------------------------------------------------

  const isSaveTemplateButtonDisabled = (): boolean => {
    const subsectionData = qpg_subsection_data ?? [];
    if (!subsectionData.length) return true;
    const allSubsectionsFilled = subsectionData.every((subsection) =>
      areAllSubSectionQuestionsFilled(subsection.subSectionQuestions)
    );
    return !allSubsectionsFilled;
  };

  const isAddSectionButtonDisabled = (): boolean => {
    const subsectionData = qpg_subsection_data ?? [];
    if (!subsectionData.length) return true;
    const allSubsectionsFilled = subsectionData.every((subsection) =>
      areAllSubSectionQuestionsFilled(subsection.subSectionQuestions)
    );
    if (qpg_settings_config?.allow_ai_questions) {
      return !allSubsectionsFilled;
    }
    const hasRemaining = hasAnyQuestionTypeRemaining(
      subsectionData,
      qpg_settings_config?.no_ofQuestions_by_types
    );
    return !allSubsectionsFilled || !hasRemaining;
  };

  // ----------------------------------------------------

  const fetchSectionTemplates = async () => {
    try {
      const response =
        await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.getQuestionPaperTemplate(
          {
            personId: BigInt(teacher_id),
            taskType: TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM,
          }
        );
      if (response.questionPaperTemplates) {
        dispatch(setQPGGeneratedTemplates(response.questionPaperTemplates));
      }
    } catch (error) {
      setLoading('error');
      dispatch(
        setToastInfoV2({
          label: 'Error while fetching section templates',
          variant: 'error',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const saveSectionTemplates = async (templateName: string) => {
    try {
      const response =
        await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.createQuestionPaperTemplate(
          {
            templateTitle: templateName,
            teacherId: teacher_id,
            subjectId: Number(subject_id),
            taskType: TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM,
            includeAiQuestions:
              qpg_settings_config?.allow_ai_questions ?? false,
            multiSubjectSectionTemplate: createMultiSubjectSectionTemplate({
              multiSubjectSection:
                qpg_content?.multiSubjectSections?.[
                  qpg_selected_section_index ?? 0
                ],
              subsectionData: qpg_subsection_data ?? [],
            }),
          }
        );
      if (response.status === 200) {
        dispatch(
          setToastInfo({
            label: 'Section Template Saved Successfully',
            variant: 'success',
            open: true,
          })
        );
      } else {
        dispatch(
          setToastInfo({
            label: 'Section Template Save Failed',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        setToastInfo({
          label: 'Section Template Save Failed',
          variant: 'success',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const handleAddMoreQuestionType = (subSectionIndex: number) => {
    const currentSubSectionData = qpg_subsection_data ?? [];
    const subsection = currentSubSectionData[subSectionIndex];
    if (!subsection) return;
    if (!areAllSubSectionQuestionsFilled(subsection.subSectionQuestions))
      return;

    const updatedSubSectionData = currentSubSectionData.map((sub, i) =>
      i === subSectionIndex
        ? new SubSectionTypeV2({
            ...sub,
            subSectionQuestions: [
              ...(sub.subSectionQuestions ?? []),
              new SubSectionQuestionType({
                questionType: Question_QuestionEnum.QUESTION_TYPE_UNDEFINED,
                noOfQuestion: 0,
                marks: 0,
              }),
            ],
          })
        : sub
    );
    dispatch(setQPGSubsectionData(updatedSubSectionData));

    // Add new question-type slot to qpg_content subSectionMetaData for the subsection
    const sectionIndex = qpg_selected_section_index ?? 0;
    if (qpg_content?.multiSubjectSections?.[sectionIndex]) {
      const sections = [...qpg_content.multiSubjectSections];
      const selectedSection = cloneObject(
        qpg_content.multiSubjectSections[sectionIndex]
      );
      const subSections = selectedSection.multiSubjectSubSections ?? [];
      const targetSubSection = subSections[subSectionIndex];
      if (targetSubSection) {
        const currentMeta = targetSubSection.subSectionMetaData ?? [];
        const updatedSubSections = subSections.map((sub, i) =>
          i === subSectionIndex
            ? new MultiSubjectSubSection({
                ...sub,
                subSectionMetaData: [
                  ...currentMeta,
                  new SectionQuestionMetaData({}),
                ],
              })
            : sub
        );
        selectedSection.multiSubjectSubSections = updatedSubSections;
        sections[sectionIndex] = selectedSection;
        const updatedContent = cloneObject(qpg_content);
        updatedContent.multiSubjectSections = sections;
        dispatch(setQPGContent(updatedContent));
      }
    }
  };

  // ----------------------------------------------------

  const onDragEnd = (result: any) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;

    const sectionIndex = qpg_selected_section_index ?? 0;
    const currentSubSectionData = qpg_subsection_data ?? [];
    const reorderedSubSections = [...currentSubSectionData];
    const [draggedSubSection] = reorderedSubSections.splice(
      result.source.index,
      1
    );
    reorderedSubSections.splice(result.destination.index, 0, draggedSubSection);
    const reorderedWithSectionNumbers = reorderedSubSections.map(
      (sub, i) =>
        new SubSectionTypeV2({
          ...sub,
          sectionNumber: i + 1,
          subSectionName: `Sub Section ${sectionIndex + 1} ${numberToAlphabet(
            i + 1
          )}`,
        })
    );
    dispatch(setQPGSubsectionData(reorderedWithSectionNumbers));

    const listCopy = [...selectedSectionList];
    const draggedItem = listCopy.splice(result.source.index, 1)[0];
    listCopy.splice(result.destination.index, 0, draggedItem);
    setSelectedSectionList(listCopy);
    dispatch(
      setCurrentQPGTemplateInfo({
        ...current_qpg_template_info,
        questionSectionInfo: listCopy,
      })
    );

    // Keep qpg_content.multiSubjectSections in sync with subsection order
    if (qpg_content?.multiSubjectSections?.[sectionIndex]) {
      const sections = [...qpg_content.multiSubjectSections];
      const selectedSection = cloneObject(
        qpg_content.multiSubjectSections[sectionIndex]
      );
      const subSections = selectedSection.multiSubjectSubSections ?? [];
      const reorderedSubSectionsContent = [...subSections];
      const [draggedContent] = reorderedSubSectionsContent.splice(
        result.source.index,
        1
      );
      reorderedSubSectionsContent.splice(
        result.destination.index,
        0,
        draggedContent
      );
      selectedSection.multiSubjectSubSections = reorderedSubSectionsContent.map(
        (sub, i) =>
          new MultiSubjectSubSection({
            ...sub,
            subSectionNo: i + 1,
            subSectionName: `Sub Section ${sectionIndex + 1} ${numberToAlphabet(
              i + 1
            )}`,
          })
      );
      sections[sectionIndex] = selectedSection;
      const updatedContent = cloneObject(qpg_content);
      updatedContent.multiSubjectSections = sections;
      dispatch(setQPGContent(updatedContent));
    }
  };

  // ----------------------------------------------------

  const createSubSectionDataFromTemplate = (templateId: number) => {
    /**
     * - Finds the template by templateId in generated_qpg_templates.
     * - Returns early if the template has no subSectionTemplate.
     * - Processes subsections in order; first subsection gets priority for each question type.
     * - For each subsection: allocates from remaining-by-type (config minus already allocated in previous subsections).
     * - Caps each subsection's question counts by remaining; only types with allowed > 0 are included.
     * - Removes any subsection that ends up with no question types.
     */
    const templateData = generated_qpg_templates?.find(
      (template) => Number(template.questionPaperTemplateId) === Number(templateId)
    );

    const multiSubjectSectionTemplate =
      templateData?.multiSubjectSectionTemplate;
    if (!multiSubjectSectionTemplate?.subSectionTemplate?.length) {
      return;
    }

    const noOfQuestionsByTypes = qpg_settings_config?.no_ofQuestions_by_types;
    const remainingByType = getInitialRemainingByType(noOfQuestionsByTypes);

    const updatedSubSectionData = multiSubjectSectionTemplate.subSectionTemplate
      .map((sub) => {
        const subSectionQuestions: SubSectionQuestionType[] = (
          sub.subSectionQuestionTemplate ?? []
        )
          .map((q) => {
            const questionType =
              q.questionType ?? Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;
            if (
              questionType === Question_QuestionEnum.QUESTION_TYPE_UNDEFINED
            ) {
              return null;
            }
            const templateNoOfQuestion = q.noOfQuestion ?? 0;
            const remaining =
              remainingByType.get(questionType) ?? Number.MAX_SAFE_INTEGER;
            const remainingNum =
              remaining === Number.MAX_SAFE_INTEGER ? 999 : remaining;
            const allowed = Math.min(templateNoOfQuestion, remainingNum);
            return { q, questionType, allowed };
          })
          .filter((item): item is NonNullable<typeof item> => item !== null)
          .filter(({ allowed }) => allowed > 0)
          .map(({ q, questionType, allowed }) => {
            const current = remainingByType.get(questionType) ?? 0;
            remainingByType.set(questionType, Math.max(0, current - allowed));
            return new SubSectionQuestionType({
              questionType: q.questionType,
              noOfQuestion: allowed,
              marks: q.marks ?? 0,
              isAlternateEnable: q.isAlternateEnable ?? false,
            });
          });

        return new SubSectionTypeV2({
          subSectionName: sub.subSectionTittle ?? '',
          sectionNumber: sub.subSectionNumber ?? 0,
          subSectionQuestions,
        });
      })
      .filter((subsection) => subsection.subSectionQuestions.length > 0);

    dispatch(setQPGSubsectionData(updatedSubSectionData));
  };

  // ----------------------------------------------------

  useEffect(() => {
    fetchSectionTemplates();

    // createSubSectionDataFromTemplate(127);
    const sectionTemplateId =
      qpg_content?.multiSubjectSections?.[qpg_selected_section_index ?? 0]
        .templateId;
    if (sectionTemplateId) {
      createSubSectionDataFromTemplate(sectionTemplateId);
    }
  }, []);

  useEffect(() => {
    dispatch(
      setQPGSettingsConfig({
        ...qpg_settings_config,
        prompt: undefined,
        prompt_validated: undefined,
      })
    );
  }, [selectedSectionList]);

  useEffect(() => {
    if (selectedSectionList && selectedSectionList?.length > 0) {
      if (selectedSectionList?.every((e) => e.noOfQuestion > 0)) {
        setIsTemplateValid(true);
      } else {
        setIsTemplateValid(false);
      }
    } else {
      setIsTemplateValid(false);
    }
  }, [selectedSectionList]);

  // ----------------------------------------------------

  if (loading === 'loading') return <Loader />;

  const showPromptEditor =
    (qpg_subsection_data?.length ?? 0) > 0 &&
    !!qpg_settings_config?.allow_ai_questions;

  return (
    <Box sx={style.root}>
      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        sx={{ marginY: { xs: pxToRem(8), md: pxTovW(12) } }}
      >
        <span style={{ color: '#007CDC' }}>Step 3: </span> Add Sub Sections and
        Choose Question types
      </Typography>

      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        color="primary.main"
        sx={{ marginY: { xs: pxToRem(4), md: pxTovW(8) } }}
      >
        {`Total: ${totalMarks} / ${preferredMarks} Marks`}
      </Typography>

      <Box sx={style.subSectionAndPromptBox}>
        <Box
          sx={{
            ...style.subSectionAndAddBox,
            width: {
              xs: '100%',
              md: !showPromptEditor ? '70%' : '100%',
            },
          }}
        >
          {qpg_subsection_data && qpg_subsection_data?.length === 0 ? (
            <AddSectionCTA
              addSectionClickHandler={() => handleAddSection()}
              selectTemplateHandler={(template: QuestionPaperTemplate) => {
                const sectionList = template.questionSectionInfo.map((val) => {
                  return new QuestionSection({
                    ...val,
                    marks:
                      val.marks ||
                      (val.questionType &&
                        !val.marks &&
                        qpg_settings_config?.question_type_marks?.find(
                          (e) => e.questionType === val.questionType
                        )?.marks) ||
                      0,
                  });
                });
                setSelectedSectionList(sectionList);
                dispatch(
                  setCurrentQPGTemplateInfo({
                    ...template,
                    questionSectionInfo: sectionList,
                  })
                );
              }}
            />
          ) : (
            <Box sx={style.subSectionBox}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="sections">
                  {(provided) => (
                    <Box
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      sx={{ width: '100%' }}
                    >
                      {qpg_subsection_data?.map(
                        (subSectionDetails, subSectionIndex) => (
                          <Draggable
                            key={'section_' + subSectionIndex}
                            draggableId={'section_' + subSectionIndex}
                            index={subSectionIndex}
                          >
                            {(provided) => (
                              <Box
                                key={subSectionIndex}
                                sx={{
                                  ...style.qpgSubSectionContainer,
                                  background:
                                    dragItem.current === subSectionIndex
                                      ? '#EBF6FF'
                                      : 'transparent',
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <QPGSubSection
                                  // index={index}
                                  // section={section}
                                  updateSection={handleUpdateSubSection}
                                  deleteSection={handleDeleteSubSection}
                                  subSectionDetails={subSectionDetails}
                                  subSectionIndex={subSectionIndex}
                                  addMoreHandler={handleAddMoreQuestionType}
                                />
                              </Box>
                            )}
                          </Draggable>
                        )
                      )}
                    </Box>
                  )}
                </Droppable>
              </DragDropContext>

              <Box sx={style.saveTemplateAndAddSectionBox}>
                <PrimaryButton
                  sx={style.saveTemplateButton}
                  disabled={isSaveTemplateButtonDisabled()}
                  onClick={async () => {
                    setDisplaySaveTemplatePopup(true);
                    await interactionEvent({
                      context: 'Question_paper_generator',
                      name: 'SAVE_TEMPLATE',
                      pathSegments: pathSegments,
                      isOffline: isOffline,
                    });
                  }}
                >
                  <IconWrapper
                    name="template_white"
                    type="png"
                    parentFolder="icons"
                    customSx={style.saveTemplateIcon}
                  />
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="white"
                    sx={{ fontSize: { xs: pxToRem(13), md: pxTovW(20) } }}
                  >
                    SAVE TEMPLATE
                  </Typography>
                </PrimaryButton>

                <PrimaryButton
                  sx={style.addSectionButton}
                  disabled={isAddSectionButtonDisabled()}
                  onClick={() => handleAddSection()}
                >
                  <IconWrapper
                    name="plus-symbol-white"
                    type="png"
                    parentFolder="icons"
                    customSx={style.addSectionIcon}
                  />
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="white"
                    sx={{ fontSize: { xs: pxToRem(13), md: pxTovW(20) } }}
                  >
                    ADD SUB SECTION
                  </Typography>
                </PrimaryButton>

                {/* <PrimaryButton
                  sx={style.previewPrintableButton}
                  disabled={isSaveTemplateButtonDisabled()}
                  onClick={async () => {
                    // TODO: Implement preview printable paper
                  }}
                >
                  <PrintIcon sx={style.previewPrintableIcon} />
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="white"
                    sx={{ fontSize: { xs: pxToRem(13), md: pxTovW(20) } }}
                  >
                    PREVIEW PRINTABLE PAPER
                  </Typography>
                </PrimaryButton> */}
              </Box>
            </Box>
          )}
        </Box>

        {showPromptEditor ? (
          <Box sx={style.aiPromptTextEditorBox}>
            <AiPromptTextEditor
              value={qpg_settings_config?.prompt}
              validationEnabled={showPromptEditor}
              validated={qpg_settings_config?.prompt_validated}
              onValidateClick={async () => {
                if (!qpg_settings_config?.prompt) {
                  return;
                }
                try {
                  setLoading('loading');
                  const res =
                    await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.checkValidPrompt(
                      {
                        subject:
                          getTeacherSubjectName(
                            subjectId,
                            user_info?.teachClassSubjects
                          ) || '',
                        moduleIds,
                        bloomLevels: qpg_settings_config?.bloomLevels || [],
                        questionSectionInfo: (
                          qpg_subsection_data ?? []
                        ).flatMap((sub, subIdx) =>
                          (sub.subSectionQuestions ?? []).map(
                            (q) =>
                              new QuestionSection({
                                sectionName: sub.subSectionName ?? '',
                                questionType:
                                  q.questionType ??
                                  Question_QuestionEnum.QUESTION_TYPE_UNDEFINED,
                                noOfQuestion: q.noOfQuestion ?? 0,
                                marks: q.marks ?? 0,
                                isAlternateEnable: q.isAlternateEnable ?? false,
                                sectionNumber: subIdx + 1,
                              })
                          )
                        ),
                        avgDifficultyLevel: getDifficultyLevelFromString(
                          qpg_settings_config?.overallDifficultyLevel ||
                            'Medium'
                        ),
                        customPrompt: qpg_settings_config?.prompt,
                        teacherId: user_info?.teacherProfileId,
                        assessmentCreationType:
                          AssessmentCreationEnum.ASSESSMENT_CREATION_QUESTION_PAPER,
                      }
                    );
                  if (res.isValidated) {
                    dispatch(
                      setQPGSettingsConfig({
                        ...qpg_settings_config,
                        prompt_validated: 'success',
                      })
                    );
                    setValidationStatus({
                      type: 'success',
                      message: 'Prompt validated! Ready to use.',
                    });
                  } else {
                    dispatch(
                      setQPGSettingsConfig({
                        ...qpg_settings_config,
                        prompt_validated: 'error',
                      })
                    );
                    setValidationStatus({
                      type: 'error',
                      heading: 'Invalid Prompt',
                      message: (
                        (res.message || '') + ' Please review and try again.'
                      ).trim(),
                    });
                  }
                } catch (err) {
                  console.log(err);
                  setValidationStatus({
                    type: 'error',
                    heading: 'Some error occurred',
                    message:
                      'Error while validating prompt. Please try after some time',
                  });
                } finally {
                  setLoading('completed');
                }
              }}
              onChange={(val) => {
                dispatch(
                  setQPGSettingsConfig({
                    ...qpg_settings_config,
                    prompt: val,
                    prompt_validated: undefined,
                  })
                );
              }}
              helperText="Describe the content to be generated. This applies to any subsection configured to generate passages or questions."
              // helperFooter={
              //   <QPGPromptSuggestionButtons
              //     value={qpg_settings_config?.prompt}
              //     onSelect={(prompt) => {
              //       dispatch(
              //         setQPGSettingsConfig({
              //           ...qpg_settings_config,
              //           prompt,
              //           prompt_validated: undefined,
              //         })
              //       );
              //     }}
              //   />
              // }
              rootStyles={style.aiPromptTextEditorRootBox}
            />
          </Box>
        ) : null}
      </Box>

      <ValidationPopup
        open={!!validationStatus}
        handleClose={() => {
          setValidationStatus(undefined);
        }}
        okHandler={() => {
          setValidationStatus(undefined);
        }}
        iconname={
          validationStatus?.type == 'success'
            ? 'check-green'
            : validationStatus?.type == 'error'
            ? 'wrong'
            : undefined
        }
        text1={validationStatus?.heading}
        text2={validationStatus?.message}
      />

      <SaveTemplatePopup
        open={displaySaveTemplatePopup}
        handleClose={() => setDisplaySaveTemplatePopup(false)}
        saveTemplateHandler={(template) => {
          saveSectionTemplates(template);
          // fetchSectionTemplates();
        }}
      />
    </Box>
  );
};

// ==============================================================

interface IAddSectionProps {
  addSectionClickHandler: () => void;
  selectTemplateHandler: (template: QuestionPaperTemplate) => void;
}
const AddSectionCTA = (props: IAddSectionProps) => {
  const { addSectionClickHandler, selectTemplateHandler } = props;
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { generated_qpg_templates } = deserify(
    useAppSelector((state) => state.assessment)
  );
  const ismobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      sx={{
        // width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: pxToRem(20), md: pxTovW(20) },
      }}
    >
      {/* <Box
        sx={{
          // width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          marginY: { xs: pxToRem(23), md: pxTovW(41) },
        }}
      >
        <Typography variant="h2">Add Sections to the Question Paper</Typography>
      </Box> */}

      <PrimaryButton
        sx={{
          width: { xs: 'unset', md: pxTovW(397) },
          height: { xs: pxToRem(48), md: pxTovW(77) },
          gap: { xs: pxToRem(10), md: pxTovW(10) },
          backgroundColor: '#007CDC',
          '&:hover': {
            backgroundColor: '#007CDC',
          },
        }}
        onClick={addSectionClickHandler}
      >
        <AddIcon
          sx={{
            color: '#fff',
            backgroundColor: '#033661',
            fontSize: { xs: pxToRem(20), md: pxTovW(30) },
            borderRadius: '50%',
            p: '3px',
          }}
        />
        <Typography
          variant={ismobile ? 'h4' : 'h2'}
          fontWeight="bold"
          color="white"
          sx={{
            fontSize: { xs: pxToRem(18), md: pxTovW(30), lg: pxTovW(24) },
          }}
        >
          ADD SUB SECTION
        </Typography>
      </PrimaryButton>

      {/* {generated_qpg_templates && generated_qpg_templates.length > 0 ? (
        <>
          <Divider
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '1px',
              marginY: { xs: pxToRem(10), md: pxTovW(20) },
              borderColor: '#007CDC',
              backgroundColor: '#007CDC',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: { xs: pxToRem(30), md: pxTovW(40) },
                height: { xs: pxToRem(30), md: pxTovW(40) },
                borderRadius: '50%',
                border: '1px solid #007CDC',
                backgroundColor: '#EBF6FF',
              }}
            >
              <Typography
                variant={ismobile ? 'cardText' : 'h2'}
                sx={{
                  color: '#007CDC',
                  fontSize: { xs: pxToRem(14), md: pxTovW(18) },
                  fontWeight: 'bold',
                  marginY: 'auto',
                }}
              >
                OR
              </Typography>
            </Box>
          </Divider>

          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{
              textAlign: 'center',
              marginY: { xs: pxToRem(20), md: pxTovW(40) },
            }}
          >
            Use Ready Templates to Create Question Paper
          </Typography>

          <Box sx={{ width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) } }}>
            <SelectMenu
              nofocus
              placeholder="Select Paper Format"
              value=""
              onChange={async (e) => {
                const template = generated_qpg_templates?.find(
                  (template) => template.title === e
                );
                if (template) {
                  selectTemplateHandler(template);
                }
                await interactionEvent({
                  context: 'Use_ready_template',
                  name: 'SELECT_PAPER_FORMAT',
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
              }}
              optionList={
                generated_qpg_templates?.map((template, index) => ({
                  name: template.title,
                  id: index,
                  nonEditableItem: false,
                })) || []
              }
              rootStyles={{
                height: { xs: pxToRem(40), md: pxTovW(70), lg: pxTovW(56) },
                backgroundColor: '#FFFFFF',
                border: '1px solid #55ACFF',
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:focus-visible .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select > em': {
                  // backgroundColor: 'red',
                  fontStyle: 'normal !important',
                  fontFamily: 'Lato',
                },
                // borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                width: { xs: '100%', md: pxTovW(484), lg: pxTovW(394) },
              }}
              clearIcon={true}
            />
          </Box>
        </>
      ) : null} */}
    </Box>
  );
};

// ==============================================================
